
import Vue from "vue";
import { formatDateWithTimestamp } from "@/shared/utils/common_utils";
import ChangeTrackedEvent, { ChangeTrackedEventAction } from "@/shared/models/ChangeTrackedEvent";
import { DataTableOptions } from "@/shared/models/PagingParameter";

export default Vue.extend({
    name: "EventsTable",
    props: {
        events: {
            type: Array,
            required: true,
            default: [] as ChangeTrackedEvent[],
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        headers: [
            {
                text: "Date",
                value: "timestampUTC",
                sortable: true,
                align: "start",
            },
            {
                text: "User",
                value: "user",
                sortable: true,
                align: "start",
            },
            {
                text: "Action",
                value: "action",
                sortable: true,
                align: "start",
            },
            {
                text: "Property",
                value: "property",
                sortable: true,
                align: "start",
            },
            {
                text: "Past Value",
                value: "oldValues",
                sortable: false,
                align: "start",
            },
            {
                text: "Current Value",
                value: "newValues",
                sortable: false,
                align: "start",
            },
        ],
        options: {
            sortBy: ["timestampUTC"],
            sortDesc: [true],
        } as DataTableOptions,
    }),
    methods: {
        formatDateWithTimestampForTable(date: Date): string {
            return formatDateWithTimestamp(new Date(date));
        },
        formatActionForTable(action: ChangeTrackedEventAction): string {
            return ChangeTrackedEventAction[action];
        },
    },
});
